module.exports = __webpack_public_path__ + "assets/img/extractionTarot.e3cbcc46.png";